import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/noticias',
    name: 'articulos.index',
    component: () => import('./views/NoticiasAdminIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'articulos.read',
      breadcrumb: 'Noticias',
    },
  },
]

export default routes
